import { useLiveResource } from "@lib/hooks/useLiveResource";

export function useRecordChannel(type: "Candidate" | "Client", id: string, onUpdate: () => void) {
  useLiveResource({
    channel: "RecordChannel",
    params: { type, id },
    onInvalidate: onUpdate,
  });
}
